/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var Subtract = createReactComponent("subtract", "Subtract", [["path", { "d": "M15.6 4.35V3h-1.8M8.4 3h1.8M4.8 3H3v1.8m0 5.4V8.4m0 5.4v1.8h1.35m5.85 0H8.4v.6c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C10.68 21 11.52 21 13.2 21h3c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2v-3c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 8.4 17.88 8.4 16.2 8.4h-.6v1.8m-1.8 5.4h1.8v-1.8", "key": "svg-0" }]]);

export { Subtract as default };
//# sourceMappingURL=Subtract.js.map
